//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ShopByIdRetrieve } from '@api/seller.service'
import { getShopStatisticsResource } from '@api/store.service'
import pathOr from 'ramda/src/pathOr'

function getStoreAge(createdAtStr) {
  if (!createdAtStr) return { years: 0, months: 0 };
  const [datePart] = createdAtStr.split(' ');
  const [day, month, year] = datePart.split('.').map(Number);
  const createdDate = new Date(year, month - 1, day);
  const now = new Date();

  let years = now.getFullYear() - createdDate.getFullYear();
  let months = now.getMonth() - createdDate.getMonth();

  if (0 > months) {
    years -= 1;
    months += 12;
  }

  return { years, months };
}

export default {
  props: ['info', 'classes'],
  data() {
    return {
      // i need backend
      test_ratings: [
        { stars: 5, count: 154 },
        { stars: 4, count: 74 },
        { stars: 3, count: 33 },
        { stars: 2, count: 22 },
        { stars: 1, count: 11 },
      ],
      rates: [
        {
          key: '5',
          label: this._('Отлично'),
          icon: 'dashboard_new',
        },
        {
          key: '4',
          label: this._('Хорошо'),
          icon: 'dashboard_in_work',
        },
        {
          key: '3',
          label: this._('Нормально'),
          icon: 'dashboard_processing',
        },
        {
          key: '2',
          label: this._('Так себе'),
          icon: 'dashboard_success',
        },
        {
          key: '1',
          label: this._('Плохо'),
          icon: 'dashboard_failed',
        },
      ],
      shop: {},
      rates_list: [],
      stats: [
        { icon: 'StarGold', title: this._('Середня оцінка магазину'), value: this.getShopRate },
        // { icon: 'Grade', title: this._('Середня оцінка товару'), value: this.getProductRate },
        // { icon: 'Percent', title: this._('Відсоток успішних замовлень'), value: this.getPercentOfSuccessOrders },
        { icon: 'Cart', title: this._('Скільки працює на Umall'), value: this.getExperience },
      ],
    }
  },
  computed: {
    storeAge() {
      return getStoreAge(pathOr('', ['props', 'created_at'], this.shop));
    },
    storeAgeText() {
      const { years, months } = this.storeAge;
      const parts = [];
      if (0 < years) parts.push(`${years} ${this.declension(years, [this._('рік'), this._('роки'), this._('років')])}`);
      if (0 < months) parts.push(`${months} ${this.declension(months, [this._('місяць'), this._('місяці'), this._('місяців')])}`);
      return parts.length ? parts.join(' і ') : this._('менше місяця');
    },
  },
  created() {
    if (this.info) {
      this.getShop()
      this.getStats()
    }
  },
  methods: {
    declension(number, words) {
      const cases = [2, 0, 1, 1, 1, 2];
      return words[
        4 < number % 100 && 20 > number % 100
          ? 2
          : cases[5 > number % 10 ? number % 10 : 5]
      ];
    },
    getStoreAge,
    async getShop() {
      const { data } = (await ShopByIdRetrieve.execute({ id: this.info }))
      this.shop = data
    },
    async getStats() {
      const { data } = (await getShopStatisticsResource.execute({ id: this.info }))
      this.rates_list = data
    },
    getVal(list = [], val) {
      const base = this.rate(list, val) || 0
      const total = this.rate(list, 'total') || 0
      return Math.floor((base / total) * 100)
    },
    rate(list = [], val) {
      return list.find(({ title }) => title === val)?.value || 0
    },
    getShopRate() {
      return `${Number(pathOr(0, ['props', 'reviews_rate'], this.shop)).toFixed(1)} ${this._('з 5.0')}`
    },
    getExperience() {
      return this.storeAgeText
    },
  },
}
